/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../styles/components/common/PopupMobileModal.module.css';

const MobileModal: React.FC<{
	open: boolean;
	onClose: () => void;
	children: React.ReactNode;
	style?: React.CSSProperties;
}> = ({ open, onClose, children, style }) => {
	if (!open) return null;

	return (
		<div className={styles.overlay} style={style}>
			<div className={styles.modal}>{children}</div>
		</div>
	);
};

export default MobileModal;
